import * as React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useEffect, useState } from 'react';

type CatProps = {
  delay: number
  isMouseOvered: boolean
  setIsMouseOvered: (state: boolean) => void
  className?: string
};

export const Cat: React.FC<CatProps> = ({
  delay,
  isMouseOvered,
  setIsMouseOvered,
  className,
}) => {
  const [isAnimated, setIsAnimated] = useState(false);

  const controls = useAnimation();

  useEffect(() => {
    if (!isMouseOvered) {
      controls.start({
        x: [
          0,
          -100,
          -150,
          0,
        ],
        scale: [
          1,
          .8,
          1,
          1,
        ],
      });
    } else {
      controls.stop();
      controls.set({
        x: 0,
        scale: 1,
      });
    }
  }, [controls, isMouseOvered]);

  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      transition={{
        duration: .3,
        delay: .3,
      }}
    >
      <motion.svg
        className={className}
        width="251"
        height="323"
        viewBox="0 0 251 323"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        initial={{ x: -8 }}
        animate={{ x: 0 }}
        transition={{
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: .5,
          delay: delay + 1.5, // Delay to transform for hands overflow
        }}
        onMouseOver={() => setIsMouseOvered(true)}
        onMouseLeave={() => setIsMouseOvered(false)}
      >
        {/* HEAD */}
        <g clipPath="url(#First-Cat-clip0)">
          <motion.g
            initial={{ x: 200 }}
            animate={{ x: (isMouseOvered && isAnimated) ? 200 : 0 }}
            transition={{
              ease: [0.6, 0.01, -0.05, 0.95],
              duration: 1,
              delay: isAnimated ? 0 : delay + 2, // Delay to show head
            }}
            onAnimationComplete={() => !isAnimated && setIsAnimated(true)}
          >
            {/* HEAD ITSELF */}
            <path d="M109.927 88.7829C113.551 100.378 125.146 116.141 137.406 126.287C140.667 129.005 143.446 131.602 143.627 132.085C143.808 132.568 143.989 144.586 143.989 158.719C143.989 182.393 143.868 184.688 142.842 186.922C142.238 188.311 138.674 192.478 134.688 196.525C120.194 211.08 110.169 227.325 109.988 236.445C109.806 243.149 111.497 244.658 120.858 246.168C129.434 247.497 157.094 247.98 169.837 247.014L180.104 246.289L187.291 248.161C194.72 250.094 204.624 251.241 209.093 250.758C212.777 250.396 213.14 251 211.63 255.469C210.059 260.059 209.335 266.944 210.361 266.944C210.724 266.944 211.147 266.581 211.267 266.158C211.388 265.796 211.811 264.045 212.173 262.414C213.26 257.764 215.918 251 216.944 250.154C217.488 249.792 218.394 249.429 219.058 249.429C220.145 249.429 220.145 249.792 219.783 255.046C219.239 262.354 220.87 273.587 222.319 272.198C222.501 272.017 222.561 268.031 222.561 263.38C222.501 258.73 222.621 253.536 222.863 251.845C223.225 249.067 223.527 248.644 225.218 247.799C226.305 247.255 227.574 247.014 228.057 247.195C228.54 247.316 229.204 249.067 229.567 251.06C229.929 252.993 230.654 255.65 231.197 256.979C232.707 260.481 233.432 258.911 232.526 254.261C232.043 252.087 231.499 249.369 231.318 248.101L230.895 245.927L235.847 243.269C238.565 241.88 241.162 240.068 241.645 239.344C242.43 238.136 242.491 228.352 242.128 159.987L241.645 81.9585L239.531 79.6031C237.478 77.3082 229.808 73.0806 227.694 73.0806C226.366 73.0806 226.426 71.3292 227.936 66.1354C228.6 63.8404 229.144 61.4851 229.144 61.0019C229.083 59.4317 225.762 63.9008 224.916 66.6185C223.346 71.9935 223.286 72.0539 220.81 71.5708C219.602 71.3292 218.333 71.0273 218.031 70.8461C217.488 70.4837 217.911 58.7674 218.696 52.8488C218.998 50.1311 218.998 49.8895 218.092 50.6143C216.401 52.0637 215.193 56.8952 214.831 63.5989C214.649 67.1621 214.227 70.2421 213.985 70.4233C213.743 70.5441 212.838 70.5441 211.992 70.3025C210.12 69.8798 209.395 66.9205 208.972 57.7407C208.791 54.1775 208.55 51.037 208.308 50.8558C206.979 49.5272 206.074 57.2575 206.859 63.2969C207.221 66.0146 207.402 68.6115 207.221 69.0343C207.04 69.457 205.47 69.8194 203.114 69.9402C198.222 70.1817 187.533 71.6916 183.366 72.7787C180.587 73.5034 179.138 73.5034 172.495 72.6579C167.18 72.0539 159.389 71.6916 147.311 71.6916C131.669 71.6312 129.193 71.752 123.938 72.8994C110.471 75.8587 107.089 79.6635 109.927 88.7829ZM169.898 195.981C173.038 189.157 180.829 182.212 189.345 178.648C197.618 175.206 204.564 176.595 211.509 183.238C217.427 188.915 220.145 195.619 220.508 205.946C220.87 213.677 219.904 218.81 217.367 223.219C211.207 233.788 196.29 238.377 185.238 233.063C179.38 230.224 172.676 222.373 169.958 215.186C167.18 207.758 167.18 201.9 169.898 195.981ZM170.26 108.169C173.944 92.5273 188.499 83.8307 204.081 87.877C212.173 89.9908 218.092 95.1242 220.689 102.432C222.017 106.116 222.199 107.505 222.138 114.45C222.138 121.275 221.897 122.845 220.568 126.71C217.79 134.561 213.14 140.238 206.979 143.379C202.933 145.432 200.578 145.734 195.625 144.949C184.875 143.258 174.79 135.407 170.804 125.744C169.113 121.577 168.871 114.148 170.26 108.169ZM214.589 156.544C214.831 155.88 216.522 156.726 217.911 158.175C220.085 160.41 220.085 162.463 218.031 165.181C216.28 167.476 214.891 167.898 214.408 166.207C214.227 165.422 214.347 157.45 214.589 156.544Z" fill="#1F1F1F"/>
            {/* EYES */}
            <motion.g
              initial={{ x: 5, y: -15 }}
              animate={{ x: isMouseOvered ? 5 : [5, 0, 5, -4, 5], y: isMouseOvered ? -15 : [-15, 0, -20, -26, -15] }}
              transition={{
                ease: [0.6, 0.01, -0.05, 0.95],
                duration: isMouseOvered ? 1 : 5,
                delay: isAnimated ? 0 : delay + 3, // Delay to start cat looking
                repeat: Infinity,
              }}
            >
              <path d="M180.378 225.262C182.311 226.591 182.854 226.651 189.981 226.47C196.201 226.289 197.711 226.047 198.617 225.141C199.583 224.175 199.583 224.054 198.617 223.028C197.711 222.182 196.201 221.941 189.135 221.82C181.345 221.639 178.264 222.061 178.264 223.39C178.264 223.632 179.231 224.477 180.378 225.262Z" fill="#1F1F1F"/>
              <path d="M181.109 134.006C182.438 135.335 183.102 135.395 190.712 135.395C197.959 135.395 198.985 135.275 200.254 134.188L201.703 132.98L200.254 131.772C198.985 130.685 197.959 130.564 190.41 130.564C182.74 130.564 179.66 131.047 179.66 132.255C179.66 132.496 180.324 133.282 181.109 134.006Z" fill="#1F1F1F"/>
            </motion.g>
          </motion.g>
        </g>
        {/* HEAD ENDED */}
        {/* HANDS */}
        <g clipPath="url(#First-Cat-clip1)">
          <motion.g
            initial={{ x: 100 }}
            animate={{ x: [100, -20, 0] }}
            transition={{
              ease: [0.6, 0.01, -0.05, 0.95],
              duration: 1,
              // delay: 1, // Delay to show hands
              delay: delay + 1, // Delay to show hands
            }}
          >
            <motion.path
              d="M223.838 34.9352C224.744 40.7329 227.341 47.1347 229.877 49.792C231.931 51.9661 232.354 52.1473 235.373 52.1473C239.54 52.1473 240.99 51.1206 241.956 47.497C243.043 43.511 244.13 41.5181 246.788 38.6192C248.056 37.2905 249.505 34.8144 250.049 33.2442C251.317 29.5602 251.317 22.4941 250.049 18.2666C249.505 16.4548 248.962 12.5896 248.901 9.56993C248.72 4.25531 248.72 4.13453 246.546 2.20194C243.768 -0.334589 240.809 -0.455376 236.098 1.83957C230.783 4.43649 226.677 10.1135 224.744 17.4815C223.596 21.8902 223.174 30.4057 223.838 34.9352Z"
              fill="#1F1F1F"

              initial={{
                x: 0,
                scale: 1,
              }}
              animate={controls}
              transition={{
                ease: [0.6, 0.01, -0.05, 0.95],
                duration: 3.5,
                delay: delay + 5, // Delay to play with ball
                repeat: Infinity,
                repeatDelay: 11.3,
              }}
            />
            <path
              d="M224.932 295.533C225.898 304.109 228.797 311.416 233.81 317.516C237.494 322.046 240.513 323.737 243.05 322.71C245.164 321.804 246.311 319.509 247.278 313.953C247.64 311.598 248.606 308.457 249.452 306.947C251.565 302.84 251.505 296.318 249.331 291.487C247.942 288.527 247.64 286.776 247.338 280.435C246.915 272.342 246.553 271.194 243.594 268.658C241.963 267.329 241.299 267.148 239.487 267.45C228.012 269.564 223.12 279.045 224.932 295.533Z"
              fill="#1F1F1F"
            />
          </motion.g>
        </g>
        {/* HANDS ENDED */}
        <defs>
          <clipPath id="First-Cat-clip0">
            <rect width="222.052" height="133.344" fill="white" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 242.342 272.315)"/>
          </clipPath>
          <clipPath id="First-Cat-clip1">
            <rect width="323" height="251" fill="white" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 251 323)"/>
          </clipPath>
        </defs>
      </motion.svg>
    </motion.div>
  );
};